import Component from './Component';
import reducer, { actions, selectors, STATE_KEY } from './modules/slice';
import saga from './modules/saga';

export { saga, actions, reducer, selectors, STATE_KEY };
export default Component;
